import React, { useState } from 'react';
import './categorypanel.css';

const Categorypanel = () => {
  const [mainSliderImages, setMainSliderImages] = useState(["", "", "", "", ""]);
  const [startEcosystemText, setStartEcosystemText] = useState('');
  const [adImages, setAdImages] = useState([
    { title: 'B2B', image: "" },
    { title: 'B2C', image: "" },
    { title: 'IT', image: "" },
    { title: 'HEALTH CARE', image: "" },
    { title: 'FINANCIAL SERVICE', image: "" },
    { title: 'RESOURCE', image: "" },
    { title: 'ENERGY', image: "" }
  ]);
  const [status, setStatus] = useState('');

  const handleSubmit = async () => {
    // Check if all fields are filled
    const isMainSliderImagesFilled = mainSliderImages.every(image => image !== "");
    const isAdImagesFilled = adImages.every(ad => ad.title !== "" && ad.image !== "");
    const isStartEcosystemTextFilled = startEcosystemText !== "";

    if (!isMainSliderImagesFilled || !isAdImagesFilled || !isStartEcosystemTextFilled) {
      setStatus('Please fill all the fields and upload the necessary images.');
      return; // Prevent form submission if any field is incomplete
    }

    const data = {
      mainSliderImages,
      startEcosystemText,
      adImages,
    };

    try {
      const response = await fetch('/api/admin/update-category-content', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setStatus('Content updated successfully!');
      } else {
        setStatus('Update failed. Try again.');
      }
    } catch (error) {
      setStatus('Error occurred. Try again later.');
    }
  };

  const handleSliderImageChange = (index, file) => {
    const newImages = [...mainSliderImages];
    newImages[index] = file;
    setMainSliderImages(newImages);
  };

  const handleAdImageChange = (index, file) => {
    const newAdImages = [...adImages];
    newAdImages[index].image = file;
    setAdImages(newAdImages);
  };

  const handleTitleChange = (index, title) => {
    const newAdImages = [...adImages];
    newAdImages[index].title = title;
    setAdImages(newAdImages);
  };

  const handleAddAdImage = () => {
    // Add a new ad image object with a default title and empty image
    setAdImages([...adImages, { title: '', image: '' }]);
  };

  return (
    <div className="adminPanel744">
      <h2 className="header744">All Category</h2>

      {/* Section 1: Main Slider Images */}
      <div className="section744">
        <h3>Main Slider Images</h3>
        {[...Array(5)].map((_, index) => (
          <div key={index} className="inputGroup744">
            <label>Image {index + 1}</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleSliderImageChange(index, e.target.files[0])}
              className="fileInput744"
            />
          </div>
        ))}
      </div>

      {/* Section 2: Start Ecosystem Text Input */}
      <div className="section744">
        <h3>Start Ecosystem</h3>
        <textarea
          placeholder="Enter Start Ecosystem Text"
          value={startEcosystemText}
          onChange={(e) => setStartEcosystemText(e.target.value)}
          className="textField744"
          rows="4" // Controls the initial height of the textarea
        />
      </div>

      {/* Section 3: Ad Images with Unique Titles */}
      <div className="section744">
        <h3>Find Yours! Startup Categories</h3>
        {adImages.map((ad, index) => (
          <div key={index} className="inputGroup744">
            {/* Show the fixed title before input */}
            {!ad.image && (
              <div className="defaultTitle744">{ad.title}</div>
            )}
            
            {/* Title input field only shown after image is uploaded */}
            {ad.image && (
              <input
                type="text"
                value={ad.title}
                onChange={(e) => handleTitleChange(index, e.target.value)}
                placeholder={`Enter Title for Category ${index + 1}`}
                className="textInput744"
              />
            )}

            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleAdImageChange(index, e.target.files[0])}
              className="fileInput744"
            />
          </div>
        ))}
        <button onClick={handleAddAdImage} className="addImageButton744">
          Add Image
        </button>
      </div>

      {/* Submit Button */}
      <button className="submitButton744" onClick={handleSubmit}>
        Update Content
      </button>

      {/* Display status message */}
      {status && <p className="statusMessage744">{status}</p>}
    </div>
  );
};

export default Categorypanel;
